module.exports = __webpack_public_path__ + "media/images/gift-thanks-title-onigiri@2x-40042018685f10153b9e0dc1557a781c.png";